<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col cols="11" class="mx-auto pb-0" v-if="mobile()">
        <div class="text-right">
          <v-btn
            v-if="totalUsers > 0 && (isOwner || role == 'booster' || (role != 'booster' && can_view_analytics == true))"
            ref="download"
            data-testid="download-data-button"
            color="accent"
            min-width="100"
          :disabled="
            (productPlan.attributes && productPlan.attributes.name == 'Free') || isLoading
          "
          :loading="isLoading"
            class="rounded-xxl text-none px-4 download-statistics"
            @click="downloadData()"
          >
            {{ $t("downloadStatistics") }} <v-icon> mdi-download </v-icon>
          </v-btn>
          <v-chip
            v-if="productPlan.attributes && productPlan.attributes.name == 'Free' && users.length > 0"
            class="px-2"
            x-small
            color="accent"
            style="top: -18px; right: 18px"
            text-color="white"
            >PRO</v-chip
          >
        </div>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0 d-flex align-center justify-end mt-n12"
      >
        <v-btn
          v-if="totalUsers > 0 && (isOwner || role == 'booster' || (role != 'booster' && can_view_analytics == true))"
          ref="download"
          data-testid="download-data-button"
          color="accent"
          min-width="100"
          :disabled="
            (productPlan.attributes && productPlan.attributes.name == 'Free') || isLoading
          "
          :loading="isLoading"
          class="rounded-xxl text-none px-4 download-statistics"
          @click="downloadData()"
        >
          {{ $t("downloadStatistics") }} <v-icon> mdi-download </v-icon>
        </v-btn>
        <v-chip
          v-if="productPlan.attributes && productPlan.attributes.name == 'Free' && users.length > 0"
          class="px-2"
          x-small
          color="accent"
          style="top: -18px; right: 18px"
          text-color="white"
          >PRO</v-chip
        >
      </v-col>
    </v-row>
    <v-row v-if="role == 'booster'">
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="totalUsers > 0" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && usersInfo.currentPage == 1 && !loadingData && search == null" align="center">
      <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
        <EmptyPage
          :page-title="$t('emptyPeopleInActivityTitle')"
          :page-text="$t('emptyPeopleInActivityText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
    <v-row v-else align="center" class="mx-auto" :class="mobile() ? 'pa-3' : ''">
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto mb-n7"
      >
        <div v-if="!loadingData && role == 'booster'" class="d-flex flex-wrap align-center">
          <v-checkbox
            v-model="selectedAll"
            @change="selectAllUsersFromPage($event)"
            :disabled="users.length == 0"
          ></v-checkbox>
          <v-menu
              offset-y
              rounded-lg
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="no-hover ml-n3"
                  :ripple="false"
                >
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list
                class="menulist-drawer"
                data-testid="menu-list"
              >
                <v-list-item @click="selectedAll = true, selectAllUsersFromPage(true)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('allFromThisPage') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedAll = false, selectAllUsersFromPage(false)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('removeUsersNone') }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
            <v-btn 
              ref="submit"
              data-testid="remove-from-activity-button"
              type="submit"
              color="accent"
              min-width="100"
              elevation="0"
              class="rounded-xxl text-none px-4 submit ml-3" 
              @click.stop="showConfirmationDialogRemoveFromActivity"
              :disabled="selectedUsersForRemoving.length == 0"
              :loading="loadingRemovingMultipleUsers"
            >
              {{ $t('removeFromActivity') }}
            </v-btn>
        </div>
        </v-col>
      <v-col v-if="!loadingData" :cols="mobile() ? '12' : '11'" class="mx-auto px-0">
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
          data-testid="user-card"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
              data-testid="user-row"
              @click="showProgress(user)"
            >
              <v-col
                v-if="role == 'booster'"
                cols="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-3"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col 
                cols="7"
                class="d-flex justify-left align-center"
              >
                <v-avatar
                  size="38"
                  class="mr-2 ml-4"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col cols="3" class="d-flex justify-center align-center">
                <v-chip v-if="user.meta && user.meta.statistics && user.meta.statistics.completed" color="success" text-color="white" data-testid="status-finished-chip">{{ $t("finished") }}</v-chip>
                <v-chip v-else-if="user.meta && user.meta.statistics && user.meta.statistics.started" color="warning" text-color="white" data-testid="status-started-chip"> {{ $t("started") }}</v-chip>
                <v-chip v-else color="bluelight" text-color="white" data-testid="status-not-started-chip"> {{ $t("notStarted") }}</v-chip>
              </v-col>
              <v-col
                v-if="role == 'booster'"
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu v-if="userId != user.id" offset-y flat bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                      <v-icon data-testid="threedots-icon" x-large>
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      v-if="user.meta && user.meta.statistics && user.meta.statistics.certificate"
                      data-testid="download-certificate"
                      router
                      @click.stop="downloadCertificate(user)"
                    >
                      <v-list-item-title>
                        {{ $t("certificate") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="spacePermissions[user.id] == 'Booster' || spacePermissions[user.id] == 'Space Admin'"
                      :disabled="productPlan.attributes &&productPlan.attributes.name == 'Free'"
                      data-testid="promote-activity-member-to-owner"
                      router
                      @click="promoteToOwner(user)"
                    >
                      <v-list-item-title>{{ $t('promoteToOwner') }}
                        <v-chip
                        v-if="productPlan.attributes && productPlan.attributes.name == 'Free'"
                        class="px-2"
                        x-small
                        color="accent"
                        text-color="white"
                        >PRO</v-chip
                      >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                       v-if="permissions[user.id] == 'Participant'"
                      :disabled="productPlan.attributes &&productPlan.attributes.name == 'Free'"
                      data-testid="permissions-activity"
                      router
                      @click.stop="
                        selectedUser = user.attributes,
                        dialogVisiblePermissions = true,
                        selectedUserPermissions = extraPermissions[user.id];
                        confirmationDialogPermissionsTitle = $t('confirmationDialogTitlePermissions'),
                        confirmationDialogPermissionsSubmitBtn = $t('save');
                        confirmationDialogPermissionsCancelBtn = $t('cancel');
                      "
                    >
                      <v-list-item-title>
                        {{ $t("permission") }}
                        <v-chip
                        v-if="productPlan.attributes && productPlan.attributes.name == 'Free'"
                        class="px-2"
                        x-small
                        color="accent"
                        text-color="white"
                        >PRO</v-chip
                      >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="remove-user-from-activity"
                      router
                      @click.stop="
                        selectedUserForRemoving = user.attributes.email,
                        dialogVisibleRemoveUser = true,
                        confirmationDialogTitle = $t('confirmationDialogTitleRemoveUserFromActivity'),
                        confirmationDialogText = $t('confirmationDialogTextRemoveUserFromActivity'),
                        confirmationDialogSubmitBtn = $t('remove');
                        confirmationDialogCancelBtn = $t('no');
                      "
                    >
                      <v-list-item-title>
                        {{ $t("remove") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-expand-transition>
                <v-card-text
                  v-show="user.show"
                  class="overflow-x-auto"
                  data-testid="report-card"
                >
                  <span
                    v-if="error != ''"
                    data-testid="report-error-msg"
                    class="d-block text-center greytext--text"
                    >{{ error }}</span
                  >
                  <v-expansion-panels
                    v-else
                    accordion
                    multiple
                    flat
                    style="min-width: 600px"
                  >
                    <v-card
                      width="100%"
                      color="background"
                      class="grey--text"
                      elevation="0"
                    >
                      <v-row @click.stop>
                        <v-col cols="3" class="px-6">
                          {{ $t("title") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("completed") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("lastAttempt") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("visits") }}
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-progress-circular
                      v-if="user.showLoader"
                      size="70"
                      indeterminate
                      class="my-10 stats-loader-mobile"
                      color="grey"
                      data-testid="loader"
                    />
                    <v-expansion-panel
                      v-for="(page, index) in activity_pages"
                      v-else
                      :key="index"
                      :readonly="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? false : true"
                      class="text-body-2 grey--text"
                      :class="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? 'bluelightBackground rounded' : ''"
                      @click.stop
                      data-testid="row-statistics"
                    >
                      <v-expansion-panel-header
                        :hide-actions="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? false : true "
                        class="pa-0"
                      >
                        <template v-slot:actions>
                          <v-icon class="px-2"> mdi-chevron-down </v-icon>
                        </template>
                        <v-row align="center" justify="center">
                          <v-col cols="3" class="px-6">
                            <v-icon
                              v-if="page.attributes.entity_type == 'activity_page' || page.attributes.entity_type == 'scorm' "
                              small
                            >
                              mdi-text
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'quiz'"
                              small
                            >
                              mdi-chat-question-outline
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'checklist'"
                              small
                            >
                              mdi-order-bool-ascending-variant
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'survey'"
                              small
                            >
                              mdi-help-box-multiple-outline
                            </v-icon>
                            {{ page.attributes.title }}
                          </v-col>
                          <v-col
                            cols="3"
                            class="px-6"
                            data-testid="completed-state-success"
                            v-if="activity_pages_stats[user.id] &&  activity_pages_stats[user.id][page.attributes.entity_id] && activity_pages_stats[user.id][page.attributes.entity_id].completed"
                          >
                            <v-icon color="success" meddium>
                              mdi-check-circle
                            </v-icon>
                          </v-col>
                          <v-col
                            cols="3"
                            class="px-6"
                            data-testid="completed-state"
                            v-else
                          >
                          </v-col>
                          <v-col
                            cols="3"
                            :class="page.attributes.entity_type == 'quiz' ||  page.attributes.entity_type == 'checklist' ? 'px-11' : 'px-6'"
                          >
                            <span
                              v-if="activity_pages_stats[user.id] && activity_pages_stats[user.id][page.attributes.entity_id] && !loadingData"
                              :class="activity_pages_stats[user.id][page.attributes.entity_id].color"
                              >{{activity_pages_stats[user.id][page.attributes.entity_id].status}}</span>
                            <span
                              v-if="(!activity_pages_stats[user.id] || !activity_pages_stats[user.id][page.attributes.entity_id]) && !loadingData"
                              class="darktext--text"
                              >{{ $t("activityPageStatusNotStarted") }}</span
                            >
                          </v-col>
                          <v-col
                            cols="3"
                            :class="page.attributes.entity_type == 'quiz' ||  page.attributes.entity_type == 'checklist' ? 'px-13' : 'px-6'"
                          >
                            <span
                              v-if="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'scorm' || page.attributes.entity_type == 'survey'"
                              class="text-caption d-block"
                            >
                              {{ $t("attempts") }}</span
                            >
                            <span
                              v-if="activity_pages_stats[user.id] && activity_pages_stats[user.id][page.attributes.entity_id] && !loadingData"
                              class="darktext--text d-block"
                              >{{activity_pages_stats[user.id][page.attributes.entity_id].visits_attempts}}</span>
                            <span
                              v-if="
                                (!activity_pages_stats[user.id] ||
                                  !activity_pages_stats[user.id][
                                    page.attributes.entity_id
                                  ]) &&
                                !loadingData &&
                                page.attributes.entity_type != 'checklist'
                              "
                              class="darktext--text d-block"
                              >0</span
                            >
                            <span
                              v-if="(!activity_pages_stats[user.id] || !activity_pages_stats[user.id][page.attributes.entity_id]) && !loadingData && page.attributes.entity_type == 'checklist'"
                              class="darktext--text d-block"
                              >n/a</span>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="page.attributes.entity_type == 'quiz'"
                        @click.native.stop
                      >
                        <span class="text-caption">{{$t("peopleInActivityQuizStatsHeader")}}</span>
                        <v-card
                          v-for="(question, indexQuizMobile) in getQuizStats(page.attributes.entity_id,user.id)"
                          :key="indexQuizMobile"
                          rounded="lg"
                          class="my-2 solo grey--text px-4 py-2"
                          @click.stop
                        >
                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <v-clamp autoresize :max-lines="1">
                                      {{ question.question }}
                                    </v-clamp></span
                                  >
                                </template>
                                <span>{{ question.question }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="3" class="px-6">
                              {{ question.type }}
                            </v-col>
                            <v-col
                              cols="3"
                              class="px-6"
                              :class="question.color"
                            >
                              {{ question.answer }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content
                        v-if="page.attributes.entity_type == 'checklist'"
                        @click.native.stop
                      >
                        <span class="text-caption">{{$t("peopleInActivityChecklistStatsHeader")}}</span>
                        <v-card
                          v-for="(checkitem, indexChecklistMobile) in getChecklistStats(page.attributes.entity_id,user.id)"
                          :key="indexChecklistMobile"
                          rounded="lg"
                          class="my-2 solo grey--text px-4 py-2"
                          @click.stop
                        >
                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <v-clamp autoresize :max-lines="1">
                                      {{ checkitem.title }}
                                    </v-clamp></span
                                  >
                                </template>
                                <span>{{ checkitem.title }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col
                              cols="3"
                              class="px-6"
                              :class="checkitem.color"
                            >
                              {{ checkitem.answer }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-expand-transition>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover ? 8 : 2}`"
              data-testid="user-row"
              @click="showProgress(user)"
            >
              <v-col
                v-if="role == 'booster'"
                md="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-4"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col
                cols="12"
                :md="role != 'booster' ? '4' : '3'"
                class="d-flex justify-left align-center"
                :class="role != 'booster' ? 'pl-4' : ''"
              >
                <v-avatar size="38" class="mx-2">
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="ml-3">
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('name') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" :md="role != 'booster' ? '3' : '2'" class="pl-2">
                <div class="text-body-2 grey--text justify-left">
                  {{ $t("mail") }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col cols="12" md="2" align="left" class="pl-2">
                <div class="text-body-2 grey--text justify-left">
                  {{ $t("activityRole") }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ $t("activity" + permissions[user.id]) }}
                </div>
              </v-col>
              <v-col
                v-if="permissions[user.id] == 'Participant' && extraPermissions[user.id]"
                cols="12"
                md="1"
              >
                <div
                  class="text-body-2 grey--text justify-left"
                  data-testid="extra-permission"
                >
                  {{ $t("extraPermissions") }}
                </div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      medium
                      class=""
                      outlined
                      color="success"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template>
                  <div
                    v-if="extraPermissions[user.id].find( (item) => item === 'Analytics Activities' )"
                  >
                    <span>{{ $t("activitiesAnalytics") }}</span><br />
                  </div>
                  <span
                    v-if="extraPermissions[user.id].find((item) => item === 'Share Activities')"
                    >{{ $t("shareActivity") }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="1" v-else> </v-col>
              <v-col cols="12" md="2" class="d-flex justify-center align-center">
                <v-chip v-if="user.meta && user.meta.statistics && user.meta.statistics.completed" color="success" text-color="white" data-testid="status-finished-chip">{{ $t("finished") }}</v-chip>
                <v-chip v-else-if="user.meta && user.meta.statistics && user.meta.statistics.started" color="warning" text-color="white" data-testid="status-started-chip"> {{ $t("started") }}</v-chip>
                <v-chip v-else color="bluelight" text-color="white" data-testid="status-not-started-chip"> {{ $t("notStarted") }}</v-chip>
              </v-col>
              <v-col
                v-if="role == 'booster'"
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu v-if="userId != user.id" offset-y flat bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-4" icon v-bind="attrs" v-on="on">
                      <v-icon data-testid="threedots-icon" x-large>
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      v-if="user.meta && user.meta.statistics && user.meta.statistics.certificate"
                      data-testid="download-certificate"
                      router
                      @click.stop="downloadCertificate(user)"
                    >
                      <v-list-item-title>
                        {{ $t("certificate") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="spacePermissions[user.id] == 'Booster' || spacePermissions[user.id] == 'Space Admin'"
                      :disabled="productPlan.attributes &&productPlan.attributes.name == 'Free'"
                      data-testid="promote-activity-member-to-owner"
                      router
                      @click="promoteToOwner(user)"
                    >
                      <v-list-item-title>{{ $t('promoteToOwner') }}
                        <v-chip
                        v-if="productPlan.attributes && productPlan.attributes.name == 'Free'"
                        class="px-2"
                        x-small
                        color="accent"
                        text-color="white"
                        >PRO</v-chip
                      >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="permissions[user.id] == 'Participant'"
                      :disabled="productPlan.attributes &&productPlan.attributes.name == 'Free'"
                      data-testid="permissions-activity"
                      router
                      @click.stop="
                        selectedUser = user.attributes;
                        selectedUserPermissions = extraPermissions[user.id];
                        dialogVisiblePermissions = true,
                        confirmationDialogPermissionsTitle = $t('confirmationDialogTitlePermissions'),
                        confirmationDialogPermissionsSubmitBtn = $t('save');
                        confirmationDialogPermissionsCancelBtn = $t('cancel');
                      "
                    >
                      <v-list-item-title>
                        {{ $t("permission") }}
                        <v-chip
                          v-if="productPlan.attributes && productPlan.attributes.name == 'Free'"
                          class="px-2"
                          x-small
                          color="accent"
                          text-color="white"
                          >PRO
                        </v-chip
                      >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="remove-user-from-activity"
                      router
                      @click.stop="
                        selectedUserForRemoving = user.attributes.email,
                        dialogVisibleRemoveUser = true,
                        confirmationDialogTitle = $t('confirmationDialogTitleRemoveUserFromActivity'),
                        confirmationDialogText = $t('confirmationDialogTextRemoveUserFromActivity'),
                        confirmationDialogSubmitBtn = $t('remove');
                        confirmationDialogCancelBtn = $t('no');
                      "
                    >
                      <v-list-item-title>
                        {{ $t("remove") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-expand-transition>
                <v-card-text
                  v-show="user.show"
                  class="overflow-x-auto"
                  data-testid="report-card"
                >
                  <span
                    v-if="error != ''"
                    data-testid="report-error-msg"
                    class="d-block text-center greytext--text"
                    >{{ error }}</span
                  >
                  <v-expansion-panels
                    v-else
                    accordion
                    multiple
                    flat
                    style="min-width: 600px"
                  >
                    <v-card
                      width="100%"
                      color="background"
                      class="grey--text"
                      elevation="0"
                    >
                      <v-row @click.stop>
                        <v-col cols="3" class="px-6">
                          {{ $t("title") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("completed") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("lastAttempt") }}
                        </v-col>
                        <v-col cols="3" class="px-6">
                          {{ $t("visits") }}
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-progress-circular
                      v-if="user.showLoader"
                      size="70"
                      indeterminate
                      class="my-10"
                      color="grey"
                      data-testid="loader"
                    />
                    <v-expansion-panel
                      v-for="(page, index) in activity_pages"
                      v-else
                      :key="index"
                      :readonly="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? false : true"
                      class="text-body-2 grey--text"
                      :class="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? 'bluelightBackground rounded' : ''"
                      @click.stop
                      data-testid="row-statistics"
                    >
                      <v-expansion-panel-header
                        :hide-actions="
                          page.attributes.entity_type == 'quiz' ||
                          page.attributes.entity_type == 'checklist'
                            ? false
                            : true
                        "
                        class="pa-0"
                      >
                        <template v-slot:actions>
                          <v-icon class="px-2"> mdi-chevron-down </v-icon>
                        </template>
                        <v-row align="center" justify="center">
                          <v-col cols="3" class="px-6">
                            <v-icon
                              v-if="page.attributes.entity_type == 'activity_page' || page.attributes.entity_type == 'scorm'"
                              small
                            >
                              mdi-text
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'quiz'"
                              small
                            >
                              mdi-chat-question-outline
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'checklist'"
                              small
                            >
                              mdi-order-bool-ascending-variant
                            </v-icon>
                            <v-icon
                              v-if="page.attributes.entity_type == 'survey'"
                              small
                            >
                              mdi-help-box-multiple-outline
                            </v-icon>
                            {{ page.attributes.title }}
                          </v-col>
                          <v-col
                            cols="3"
                            class="px-6"
                            data-testid="completed-state-success"
                            v-if="activity_pages_stats[user.id] && activity_pages_stats[user.id][page.attributes.entity_id] && activity_pages_stats[user.id][page.attributes.entity_id].completed"
                          >
                            <v-icon color="success" meddium>
                              mdi-check-circle
                            </v-icon>
                          </v-col>
                          <v-col
                            cols="3"
                            class="px-6"
                            data-testid="completed-state"
                            v-else
                          >
                          </v-col>
                          <v-col
                            cols="3"
                            :class="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? 'px-11' : 'px-6'"
                          >
                            <span
                              v-if="activity_pages_stats[user.id] && activity_pages_stats[user.id][page.attributes.entity_id] && !loadingData"
                              :class="activity_pages_stats[user.id][page.attributes.entity_id].color"
                              >{{activity_pages_stats[user.id][page.attributes.entity_id].status}}</span>
                            <span
                              v-if="(!activity_pages_stats[user.id] || !activity_pages_stats[user.id][page.attributes.entity_id]) && !loadingData"
                              class="darktext--text"
                              >{{ $t("activityPageStatusNotStarted") }}</span
                            >
                          </v-col>
                          <v-col
                            cols="3"
                            :class="page.attributes.entity_type == 'quiz' || page.attributes.entity_type == 'checklist' ? 'px-13' : 'px-6'"
                          >
                            <span
                              v-if="page.attributes.entity_type == 'quiz' ||  page.attributes.entity_type == 'scorm' || page.attributes.entity_type == 'survey'"
                              class="text-caption d-block"
                            >
                              {{ $t("attempts") }}</span
                            >
                            <span
                              v-if="activity_pages_stats[user.id] && activity_pages_stats[user.id][page.attributes.entity_id] && !loadingData"
                              class="darktext--text d-block"
                              >{{activity_pages_stats[user.id][page.attributes.entity_id].visits_attempts}}</span>
                            <span
                              v-if="(!activity_pages_stats[user.id] || !activity_pages_stats[user.id][page.attributes.entity_id]) && !loadingData && page.attributes.entity_type != 'checklist'"
                              class="darktext--text d-block"
                              >0</span
                            >
                            <span
                              v-if="(!activity_pages_stats[user.id] || !activity_pages_stats[user.id][page.attributes.entity_id]) && !loadingData && page.attributes.entity_type == 'checklist'"
                              class="darktext--text d-block"
                              >n/a</span>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="page.attributes.entity_type == 'quiz'"
                        @click.native.stop
                      >
                        <span class="text-caption">{{$t("peopleInActivityQuizStatsHeader")}}</span>
                        <v-card
                          v-for="(question, indexQuiz) in getQuizStats(page.attributes.entity_id,user.id)"
                          :key="indexQuiz"
                          rounded="lg"
                          class="my-2 solo grey--text px-4 py-2"
                          @click.stop
                        >
                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <v-clamp autoresize :max-lines="1">
                                      {{ question.question }}
                                    </v-clamp></span
                                  >
                                </template>
                                <span>{{ question.question }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="3" class="px-6">
                              {{ question.type }}
                            </v-col>
                            <v-col
                              cols="3"
                              class="px-6"
                              :class="question.color"
                            >
                              {{ question.answer }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content
                        v-if="page.attributes.entity_type == 'checklist'"
                        @click.native.stop
                      >
                        <span class="text-caption">{{$t("peopleInActivityChecklistStatsHeader")}}</span>
                        <v-card
                          v-for="(checkitem, indexChecklist) in getChecklistStats(page.attributes.entity_id,user.id)"
                          :key="indexChecklist"
                          rounded="lg"
                          class="my-2 solo grey--text px-4 py-2"
                          @click.stop
                        >
                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <v-clamp autoresize :max-lines="1">
                                      {{ checkitem.title }}
                                    </v-clamp></span
                                  >
                                </template>
                                <span>{{ checkitem.title }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col
                              cols="3"
                              class="px-6"
                              :class="checkitem.color"
                            >
                              {{ checkitem.answer }}
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-expand-transition>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <PlusButtonWithLink
      v-if="
        isOwner || role == 'booster' || (role != 'booster' && can_share == true)
      "
      data-testid="add-people-button"
      rounded="xxl"
      :link="link"
    />
    <ConfirmationDialog
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-user"
      @close="dialogVisibleRemoveUser = false, selectedUserForRemoving = null, confirmationDialogAdditonalText = ''"
      @proceedSubmit="selectedUserForRemoving != null ? removeUser(selectedUserForRemoving) : removeUsers()"
    />

    <ConfirmationDialogPermissions
      v-if="dialogVisiblePermissions"
      ref="confirmationDialogPermissions"
      :visible="dialogVisiblePermissions"
      :cd-title="confirmationDialogPermissionsTitle"
      :cd-submit-btn="confirmationDialogPermissionsSubmitBtn"
      :cd-cancel-btn="confirmationDialogPermissionsCancelBtn"
      data-testid="confirmation-dialog-permissions"
      :user="selectedUser"
      :stat-permission="selectedUserPermissions"
      :shar-permission="selectedUserPermissions"
      @close="dialogVisiblePermissions = false"
      @proceedSubmit="optionsForPermissions"
    />
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import {
  getPeopleInActivity,
  downloadActivityPeopleData,
  removeUserFromActivity,
  getActivityPages,
  getActivityQuizQuestions,
  getActivityPagesStats,
  getActivityQuestionsStats,
  getActivityCheckitemStats,
  getChecklistItems,
  searchPeopleInActivityMembers,
  addActivityBoosters,
  removeUsersFromActivity,
  getActivity
} from "../../api/activityApi";
import { getSpaceByURL } from "../../api/spaceApi";
import Pagination from "../../components/Pagination";
import PlusButtonWithLink from "../../components/PlusButtonWithLink";
import EmptyPage from "../../components/EmptyPage";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import ConfirmationDialogPermissions from "../../components/ConfirmationDialogPermissions";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import AlertMessages from "../../components/AlertMessages";
import Vue from "vue";
import VClamp from "vue-clamp";
import SearchBarExpanding from '../../components/SearchBarExpanding'
import jsPDF from "jspdf"

export default {
  components: {
    Pagination,
    PlusButtonWithLink,
    EmptyPage,
    ConfirmationDialog,
    ConfirmationDialogPermissions,
    AlertMessages,
    VClamp,
    SearchBarExpanding
  },
  mixins: [repeatedMethodsMixin],
  props: ['role', 'isOwner', 'can_share', 'can_view_analytics'],
  data() {
    return {
      users: [],
      permissions: [],
      spacePermissions:[],
      extraPermissions: [],
      usersInfo: {
        currentPage: 1,
        total: 0,
      },
      userId: window.$cookies.get("id"),
      activityId: this.$route.params.id,
      spaceId: window.$cookies.get("space_id"),
      error: "",
      alertMsg: "",
      alertType: "",
      alertValue: false,
      defaultImage: require("../../assets/user_images/profile-avatar.png"),
      pageNumber: 1,
      size: 15,
      loadingData: false,
      dialogVisibleRemoveUser: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      confirmationDialogPermissionsTitle: "",
      confirmationDialogPermissionsCancelBtn: "",
      confirmationDialogPermissionsSubmitBtn: "",
      activity_pages: [],
      activity_quiz_questions: [],
      activity_pages_stats: {},
      activity_quiz_questions_stats: [],
      activity_checklist_checkitems_stats: [],
      link: {
        title: i18n.t('invitePeopleTitle'),
        route: "/activity/" + this.$route.params.id + "/share",
      },
      dialogVisiblePermissions: false,
      selectedUser: {},
      search: null,
      isLoading:false,
      paginationKey: '',
      selectedUsersForRemoving: [],
      selectedAll: false,
      notSelected: false,
      selected: true,
      confirmationDialogAdditonalText: '',
      visitedUsers: [],
      selectedUserForRemoving: null,
      loadingRemovingMultipleUsers: false,
      totalUsers: 0,
      activity: null,
      activityTitle: "",
      space: null,
    }
  },
  watch:{
    selectedUsersForRemoving(){
      if(this.selectedUsersForRemoving.length == 0){
        this.selectedAll = false
      }else{
        this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
      }
    }
  },
  computed: {
    productPlan() {
        return this.$store.state.productPlan;
    },
  },
  async created() {
    if (this.$route.params.successfullySharedActivity) {
      this.alertMsg = i18n.t("shareActivitySuccess");
      this.alertType = "success";
      this.alertValue = true;
    }
    this.loadingData = true;
    if ((this.role == 'participant' || this.role == 'guest') && !this.can_view_analytics) {
      this.$router.push({name: 'PageAccessDenied'})
    }
    await this.fetchPeopleInActivity();
    this.loadingData = false;
    await this.getActivityPages();
  },
  methods: {
    async searchPeople(keyword){
      this.search = keyword
        if(keyword && keyword.trim().length >= 2){
          try {
              const response = await searchPeopleInActivityMembers(this.activityId,keyword,this.pageNumber, this.size)
              if(response){
                  if(response.status == 200){
                    this.selectedUsersForRemoving = []
                    this.users = response.data.data
                    if(this.users.length == 0 && response.data.meta.total > 0){
                        this.pageNumber = 1
                        await this.searchPeople(keyword)
                    }else {
                        this.usersInfo = response.data.meta
                        if(this.pageNumber == 1){
                          this.paginationKey = Date.now()
                        }
                        this.visitedUsers.push(...response.data.data)
                        window.scrollTo(0,0)
                    }
                  }
              }
          } catch (e) {
              if(e.response){
                  this.error = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
                  this.alertValue = true
              } 
          }
        }
    },
    async resetSearch(){
        this.usersInfo.currentPage = 1
        this.pageNumber = 1
        await this.fetchPeopleInActivity()
        this.search = null
        this.paginationKey = Date.now()
        return
    },
    async handlePageChange(value){
        this.usersInfo.currentPage = value
        this.pageNumber = value
        if(this.search == null){
          await this.fetchPeopleInActivity();
        }else {
          await this.searchPeople(this.search)
        }
        this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
    },
    async optionsForPermissions() {
      this.dialogVisiblePermissions = false;
      await this.fetchPeopleInActivity();
    },
    async downloadData() {
      this.isLoading =true
      try {
        const response = await downloadActivityPeopleData(this.activityId);
        if (response.status) {
          if (response.status == 200) {
            const anchor = document.createElement("a");
            anchor.href =
              "data:text/csv;charset=utf-8," +
              encodeURIComponent(response.data);
            anchor.target = "_blank";
            anchor.download = "skillboost-statistics.csv";
            anchor.click();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
      this.isLoading =false
    },
    async downloadCertificate(participant){
      const participantStatus = participant.meta.statistics
      participant = participant.attributes

      if (participantStatus && participantStatus.certificate) {
        await this.getActivityByUUID(this.activityId)
        await this.getSpace()
        var newLogo = this.space.logo
        var newSubdomain = this.space.subdomain
        var logo = newLogo ? logo = newLogo + '?notfromcache' : logo = require('../../assets/rtplogo.svg')
        let name = participant ? participant.first_name + ' ' + participant.last_name : 'null'
        let domain = newSubdomain ? newSubdomain + '.' + process.env.VUE_APP_DOMAIN : process.env.VUE_APP_DOMAIN
        if (name && name != ' ' && logo && this.activityTitle) {
          var RobotoFont = require('../../components/RobotoFont')
          var robotoFont = new RobotoFont.RobotoFont()
          var font = robotoFont.getFont()
          var callAddFont = function () {
          this.addFileToVFS('Roboto-Regular-normal.ttf', font);
          this.addFont('Roboto-Regular-normal.ttf', 'Roboto-Regular', 'normal');
          };
          jsPDF.API.events.push(['addFonts', callAddFont])

          var doc = new jsPDF()
          let pdfName = 'Certificate_' + this.activityTitle + '_' + name

          var width = doc.internal.pageSize.getWidth()
          let pageHeight = doc.internal.pageSize.getHeight()
          
          let certificateTextPart1 = i18n.t('certificateTextPart1');
          let certificateTextPart2 = i18n.t('certificateTextPart2');
          let certificateTextPart3 = i18n.t('certificateTextPart3');
          let certificateTextDate = i18n.t('certificateTextDate');

          doc.setFont('Roboto-Regular', 'normal');
          doc.setTextColor(0, 0, 0, 0.80)
          doc.setFontSize(16)
          doc.text(certificateTextPart1, width/2, 80, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(22)
          doc.text(name, width/2, 100, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(16)
          doc.text(certificateTextPart2, width/2, 120, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(22)
          doc.text(this.activityTitle, width/2, 140, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(16)
          doc.text(certificateTextPart3, width/2, 170, { align: 'center', maxWidth: width-30 })
          doc.text(certificateTextDate + ': ' + participantStatus.certificate.created_at.slice(0, 10), width/2, 230, { align: 'center', maxWidth: width-30 })
          doc.text(domain, width/2, pageHeight-20, { align: 'center', maxWidth: width-30 })

          if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
            var XMLrequest = new XMLHttpRequest() // new XML request
            XMLrequest.crossOrigin = "anonymous"
            XMLrequest.open("GET", logo, false) // URL of the SVG file on server
            XMLrequest.send(null) // get the SVG file

            var mySVG = XMLrequest.responseXML.getElementsByTagName("svg")[0]

            var svgString = new XMLSerializer().serializeToString(mySVG)

            var data = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);

            var canvas = document.createElement('canvas')
            var svgwidth = mySVG.width.baseVal.value
            var svgheight = mySVG.height.baseVal.value
            canvas.width = svgwidth
            canvas.height = svgheight

            var ctx = canvas.getContext("2d")
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            
            var img = new Image()
            img.src = data
        
            img.onload = function() {
                let devide = this.height/28
                let imageWidth = this.width/devide
                ctx.drawImage(img, 0, 0)
                var png = canvas.toDataURL("image/png")
                doc.addImage(png, width/2-imageWidth/2, 20, imageWidth, 28)
                doc.save(pdfName + '.pdf')
            }
          } else if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpg' ||
            logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpeg' || 
            logo.split(/[#?]/)[0].split('.').pop().trim() == 'png') {
              let img = new Image
              img.src = logo
              img.crossOrigin = "anonymous"

              img.onload = function() {
                let devide = this.height/28
                let imageWidth = this.width/devide
                doc.addImage(this, width/2-imageWidth/2, 20, imageWidth, 28)
                doc.save(pdfName + '.pdf')
              }                           
          }
        }
      }
    },
    async getActivityByUUID(id) {
      if (!this.activity) {
        try {
          const response = await getActivity(id);
          if (response.status == 200) {
            this.activity = response.data.data
            this.activityTitle = this.activity.attributes.title
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async getSpace() {
      if (!this.space) {
        try {
          const response = await getSpaceByURL(window.location.host.split(".")[0]);
          if (response.status == 200) {
            this.space = response.data.data.attributes
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async fetchPeopleInActivity() {
      try {
        const response = await getPeopleInActivity(
          this.activityId,
          this.pageNumber,
          this.size
        );
        if (response.status) {
          if (response.status == 200) {
            this.users = response.data.data;
            this.permissions = response.data.meta.permissions;
            this.spacePermissions = response.data.meta.space_permissions;
            this.extraPermissions = response.data.meta.extra_permissions;
          
            if(this.users.length == 0 && response.data.meta.total > 0){
                this.pageNumber = 1
                await this.fetchPeopleInActivity()
            }else {
              this.usersInfo = response.data.meta
              this.totalUsers = response.data.meta.total
              if(this.pageNumber == 1){
                this.paginationKey = Date.now()
              }
              this.visitedUsers.push(...response.data.data)
              window.scrollTo(0,0)
            }}
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },

    async removeUser(email) {
      this.dialogVisibleRemoveUser = false;
      try {
        let data = {
          data: {
            type: "activity-users",
            attributes: {
              user_email: email,
            },
          },
        };
        const response = await removeUserFromActivity(this.activityId, data);
        if (response.status == 200) {
          if(this.search == null){
            await this.fetchPeopleInActivity()
          }else {
            await this.searchPeople(this.search)
          }
          this.selectedUsersForRemoving = []
          this.confirmationDialogAdditonalText = ''

          this.alertValue = true;
          this.alertType = "success";
          this.alertMsg = i18n.t("removeUserFromActivitySuccess");
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },

    async getActivityPages() {
      try {
        const response = await getActivityPages(this.activityId);
        if (response.status == 200) {
          this.activity_pages = response.data.data.filter(
            (page) =>
              page.attributes.is_published == true &&
              page.attributes.entity_type != "section"
          );
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async showProgress(item) {
      if(event.target.classList.contains('v-input--selection-controls__ripple')){
        return
      }
      Vue.set(item, "show", !item.show);

      for (let i = 0; i < this.users.length; i++) {
        if (item.id != this.users[i].id) {
          Vue.set(this.users[i], "show", false);
        }
      }

      if (!this.activity_pages_stats[item.id]) {
        //activity pages statistics
        Vue.set(item, "showLoader", true);

        try {
          let data = {
            data: {
              type: "activity-stats",
              attributes: {
                user_id: item.id,
              },
            },
          };
          const response = await getActivityPagesStats(this.activityId, data);
          if (response.status == 200) {
            var results = {};
            for (const [key, value] of Object.entries(
              response.data.meta.pages
            )) {
              results[key] = {
                status:
                  value.finished > 0
                    ? i18n.t("activityPageStatusFinished")
                    : i18n.t("activityPageStatusStarted"),
                visits_attempts: value.started,
                color: value.finished > 0 ? "success--text" : "warning--text",
                completed: value.completed,
              };
            }
            for (const [key, value] of Object.entries(
              response.data.meta.scorms
            )) {
              var scorm_status = i18n.t("activityPageStatusNotStarted");
              var scorm_color = "greytext--text";

              if (value.lesson_status == "failed") {
                scorm_status = i18n.t("activityPageStatusFailed");
                scorm_color = "error--text";
              }
              if (value.lesson_status == "passed") {
                scorm_status = i18n.t("activityPageStatusPassed");
                scorm_color = "success--text";
              }
              if (value.lesson_status == "completed") {
                scorm_status = i18n.t("activityPageStatusCompleted");
                scorm_color = "success--text";
              }

              if (value.lesson_status == null) {
                scorm_status = i18n.t("activityPageStatusStarted");
                scorm_color = "warning--text";
              }

              results[key] = {
                status: scorm_status,
                visits_attempts: value.attempts,
                color: scorm_color,
                completed: value.completed,
              };
            }
            for (const [key, value] of Object.entries(
              response.data.meta.quizzes
            )) {
              var quiz_status = i18n.t("activityPageStatusNotStarted");
              var quiz_color = "greytext--text";
              if (value.result) {
                if (value.result.has_passing_score) {
                  if (value.result.score >= value.result.min_passing_score) {
                    quiz_status = i18n.t("activityPageStatusSuccedded");
                    quiz_color = "success--text";
                  } else {
                    quiz_status = i18n.t("activityPageStatusFailed");
                    quiz_color = "error--text";
                  }
                } else {
                  quiz_status = i18n.t("activityPageStatusFinished");
                  quiz_color = "success--text";
                }
              } else {
                quiz_status = i18n.t("activityPageStatusStarted");
                quiz_color = "warning--text";
              }

              results[key] = {
                status: quiz_status,
                visits_attempts: value.attempts,
                color: quiz_color,
                completed: value.completed,
              };
            }

            for (const [key, value] of Object.entries(
              response.data.meta.checklists
            )) {
              results[key] = {
                status: value.finished
                  ? i18n.t("activityPageStatusFinished")
                  : i18n.t("activityPageStatusStarted"),
                visits_attempts: "n/a",
                color: value.finished ? "success--text" : "warning--text",
                completed: value.completed,
              };
            }

            for (const [key, value] of Object.entries(
              response.data.meta.surveys
            )) {
              results[key] = {
                status: value.last_attempt != 'Started'
                  ? i18n.t("activityPageStatusFinished")
                  : i18n.t("activityPageStatusStarted"),
                visits_attempts: value.attempts,
                color: value.completed ? "success--text" : "warning--text",
                completed: value.completed,
              };
            }

            this.activity_pages_stats[item.id] = results;

            //quiz questions statistics
            await this.activity_pages.forEach(async (page) => {
              if (page.attributes.entity_type == "quiz") {
                let data = {
                  data: {
                    type: "activity-stats",
                    attributes: {
                      user_id: item.id,
                      quiz_id: page.attributes.entity_id,
                    },
                  },
                };

                const response_question_stats = await getActivityQuestionsStats(
                  this.activityId,
                  data
                );
                var questions_stats =
                  response_question_stats.data.meta.questions;
                const response = await getActivityQuizQuestions(
                  page.attributes.entity_id
                );
                var results_quiz = {};
                response.data.data.forEach((question) => {
                  var question_type = "";
                  if (question.attributes.type == 1) {
                    if (question.attributes.options[0].answer == null) {
                      question_type = i18n.t("singleChoiceImageAnswers");
                    } else {
                      question_type = i18n.t("singleChoiceTextAnswers");
                    }
                  } else {
                    if (question.attributes.options[0].answer == null) {
                      question_type = i18n.t("multipleChoiceImageAnswers");
                    } else {
                      question_type = i18n.t("multipleChoiceTextAnswers");
                    }
                  }
                  var question_answer = "";
                  var question_answer_color = "";
                  if (questions_stats[question.id]) {
                    question_answer = questions_stats[question.id]["result"]
                      ? i18n.t("activityQuestionCorrectAnswer")
                      : i18n.t("activityQuestionWrongAnswer");
                    question_answer_color = questions_stats[question.id][
                      "result"
                    ]
                      ? "success--text"
                      : "error--text";
                  }

                  results_quiz[question.id] = {
                    question: question.attributes.question,
                    type: question_type,
                    answer: question_answer,
                    color: question_answer_color,
                  };
                });
                this.activity_quiz_questions_stats.push({
                  user: item.id,
                  id: page.attributes.entity_id,
                  result: results_quiz,
                });
              }

              if (page.attributes.entity_type == "checklist") {
                let data = {
                  data: {
                    type: "activity-stats",
                    attributes: {
                      user_id: item.id,
                      checklist_id: page.attributes.entity_id,
                    },
                  },
                };

                const response_checkitem_stats =
                  await getActivityCheckitemStats(this.activityId, data);
                var checkitems_stats =
                  response_checkitem_stats.data.meta.checkitems;
                const response = await getChecklistItems(
                  page.attributes.entity_id
                );
                var results_checklist = {};
                response.data.data.forEach((checkitem) => {
                  var checkitem_answer = "";
                  var checkitem_answer_color = "";
                  if (checkitems_stats[checkitem.id]) {
                    checkitem_answer = checkitems_stats[checkitem.id]["checked"]
                      ? i18n.t("activityChecklistChecked")
                      : i18n.t("activityChecklistNotChecked");
                    checkitem_answer_color = checkitems_stats[checkitem.id][
                      "checked"
                    ]
                      ? "success--text"
                      : "error--text";
                  }
                  results_checklist[checkitem.id] = {
                    title: checkitem.attributes.title,
                    answer: checkitem_answer,
                    color: checkitem_answer_color,
                  };
                });
                this.activity_checklist_checkitems_stats.push({
                  user: item.id,
                  id: page.attributes.entity_id,
                  result: results_checklist,
                });
              }
            });
          }
        } catch (e) {
          if (e.response) {
            this.error = i18n.t("dataNotRetrievedError");
          }
        }
        Vue.set(item, "showLoader", false);
      }
    },

    getQuizStats(id, user) {
      var newArray = this.activity_quiz_questions_stats.filter(function (el) {
        return el.id == id && el.user == user;
      });
      if (newArray[0]) {
        return newArray[0].result;
      }
    },

    getChecklistStats(id, user) {
      var newArray = this.activity_checklist_checkitems_stats.filter(function (
        el
      ) {
        return el.id == id && el.user == user;
      });
      if (newArray[0]) {
        return newArray[0].result;
      }
    },
    async promoteToOwner(user){
       try {
              let data = {
                  data: {
                      type: "activity-users", 
                      attributes: {
                          user_email: [user.attributes.email],
                      }
                  }
              };
              const response = await addActivityBoosters(this.$route.params.id, data)
              if(response.status == 200) {
                await this.fetchPeopleInActivity();
                  this.alertValue = true
                  this.alertType = 'success'
                  this.alertMsg =  i18n.t('promoteToOwnerSuccess')
              }            
          } catch (e) {
              if(e.response){
                  this.alertValue = true
                  if(e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else if(e.response.status == 404) {
                      this.$router.push({name: 'PageNotFound'})
                  } else {
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }            
          }
         
        },

        async removeUsers(){
            this.dialogVisibleRemoveUser = false
            this.loadingRemovingMultipleUsers = true
            try{
                let data = {
                    data: {
                        type: "activity-users", 
                        attributes: {
                            users: this.selectedUsersForRemoving
                        },
                    }
                }
                const response = await removeUsersFromActivity(this.activityId, data)
                if(response.status == 200) {
                    if(this.search == null){
                      await this.fetchPeopleInActivity()
                    }else {
                      await this.searchPeople(this.search)
                    }
                    this.selectedUsersForRemoving = []
                    this.confirmationDialogAdditonalText = ''
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeUsersFromActivitySuccess')
                }
            } catch (e) {
                if(e.response){
                    this.confirmationDialogAdditonalText = ''
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
            this.loadingRemovingMultipleUsers = false
        },
        selectAllUsersFromPage(event){
          if(event){
            this.users.forEach(user => {
              if(!this.selectedUsersForRemoving.includes(user.id)){
                this.selectedUsersForRemoving.push(user.id)
              }
            })
          }else {
            this.users.forEach(user => {
              this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
            })
          }
        },
        selectUser(event, user){
          if(event){
            if(!this.selectedUsersForRemoving.includes(user.id)){
              this.selectedUsersForRemoving.push(user.id)
            }
          }else{
            this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
          }
        },
        showConfirmationDialogRemoveFromActivity(){
          this.selectedUsersForRemoving.forEach(item => {
            const user = this.visitedUsers.find(user => user.id == item)
            this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">' + user.attributes.first_name + ' ' + user.attributes.last_name + '</p>'
          });
          this.dialogVisibleRemoveUser= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleRemoveUsersFromActivity')
          this.confirmationDialogText= i18n.t('confirmationDialogTextRemoveUsersFromActivity')
          this.confirmationDialogSubmitBtn= i18n.t('remove')
          this.confirmationDialogCancelBtn= i18n.t('no')
        },
  },
};
</script>
<style>
.bluelightBackground .v-icon.mdi-check-circle {
  margin-left: 10px;
}
</style>